import { Component } from '@angular/core';
import { NavigationService } from "@shared/services/navigation-service.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { cloneDeep } from "lodash";
import { EcommerceService } from '../ecommerce.service';
import { ToastService } from '@app/shared/services/toast.service';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent {

  public params: any;
  public totalItems: any;
  public totalPages: any;
  public dataList: any;
  public totalOrders: any;
  public totalOrderBalance: any;
  public PAGE_PATH = 'ecommerce/orders'
  public orderStatusColor: any = {
      PENDING: '#867402',
      IN_PROGRESS: '#028639',
      READY: '#028681',
      DELIVERED: '#304fff',
      REJECTED: '#ff3030',
  }


  constructor(public service: EcommerceService,
    public navigation: NavigationService,
    public spinner: NgxSpinnerService,
    public router: Router,
    public route: ActivatedRoute,
    public toast: ToastService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.initQueryParamMap();
  }


  public initQueryParamMap() {
    this.route.queryParamMap
      .subscribe((params: any) => {
        this.params = params.params.page ? cloneDeep(params.params) : {
          page: 1,
          srt: 'date',
          srtd: 'desc',
        };
        this.getItems();
      }
      );
  }


  public getItems() {
    this.service.getOrdersStats(this.params).subscribe((res: any) => {
      this.totalOrders = res.totalOrders;
      this.totalOrderBalance = res.totalOrderBalance;
    }, error => {
      console.log(error);
      this.spinner.hide();

    });

    this.service.getOrders(this.params).subscribe((res: any) => {
      this.dataList = res.data;
      this.totalItems = res.total;
      this.totalPages = Math.ceil(parseInt(res.total.toString()) / 5);
      this.totalPages = this.totalPages == 0 ? 1 : this.totalPages;
      this.spinner.hide();

    }, error => {
      console.log(error);
      this.spinner.hide();

    });
  }

  backClick(event: any) {
    this.params.page--;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  nextClick(event: any) {
    this.params.page++;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  doSearchByEnter(val: any) {
    this.params.page = 1;
    this.params.search = val?.target?.value;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);

  }

  doSearchByKeyUp(event: any) {
    this.params.search = event.target.value;
    if (this.params.search.length > 3 && event.key !== 'Enter') {
      this.params.page = 1;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
    if (this.params.search.length === 0) {
      delete this.params.search;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
  }

  public goToDetails(id: any) {
    this.router.navigate(['/ecommerce/orders/' + id])
  }
}
